<template>
    <div class="top-listens">
        <h3 class="widget-title">
            {{ computedTitle }}
        </h3>
        <data-loader :data="topListens">
            <div class="columns" :class="`columns-${columns.length}`">
                <div v-for="(column, key) in columns" :key="key" class="column">
                    <div class="labels">
                        <span>Episode Name</span>
                        <span>Listens</span>
                    </div>

                    <ol class="episodes-list">
                        <li
                            v-for="item in column"
                            :key="item.episode.guid"
                            class="episode"
                            >
                            <div class="episode-description">
                                <h4 class="episode-title">
                                    {{ item.episode.title }}
                                </h4>
                                <p class="episode-show">
                                    {{ item.show.title }}
                                </p>
                            </div>
                            <p class="listens">
                                {{ format(item.totalListens) }}
                            </p>
                        </li>
                    </ol>
                </div>
            </div>
        </data-loader>
    </div>
</template>

<script>

/**
 * External dependencies
 */
import { chunk } from 'lodash';
import { mapActions, mapState } from 'vuex';

/**
 * Internal dependencies
 */
import analyticsData from '@/mixins/analyticsData';
import DataLoader from '@/components/DataLoader';
import format from '@/utils/numberFormat';

export default {
    components: {
        DataLoader,
    },

    mixins: [
        analyticsData,
    ],

    props: {
        from: {
            type: String,
            default: null,
        },
        itemsPerColumn: {
            type: Number,
            default: 5,
        },
        limit: {
            type: Number,
            default: 5,
        },
        showHash: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        to: {
            type: String,
            default: null,
        },
    },

    computed: {
        ...mapState({
            analyticsData: 'topListens',
        }),

        /**
         * Returns top episodes.
         *
         * @returns {Array|null} Top episodes.
         */
        topListens() {
            return this.analyticsData?.[this.key];
        },

        /**
         * Returns top listens divided into columns.
         *
         * @returns {Array} Columns.
         */
        columns() {
            if (! this.topListens) {
                return [];
            }

            return chunk(this.topListens, this.itemsPerColumn);
        },

        /**
         * Returns section title.
         *
         * @returns {string} Section title.
         */
        computedTitle() {
            return this.title || `Top ${this.limit} Episodes`;
        },

        /**
         * Retrives current show from store based on selected show hash.
         *
         * @returns {object|null} Current show or null if not selected.
         */
        show() {
            return this.showHash ? (this.$store.state.shows?.[this.showHash] || null) : null;
        },
    },

    watch: {
        /**
         * Sets limit as analiticsDataParams item.
         *
         * @returns {void}
         */
        limit() {
            this.analiticsDataParams = { limit: this.limit };
        },
    },

    methods: {
        ...mapActions({
            loadData: 'loadTopListens',
        }),

        format,
    },
};
</script>
